import { TranslatePipe } from "@ngx-translate/core";

import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";

import { WirelessHealthDetail } from "../../../apis/networkdashboard/rest/models";

@Component({
  selector: "user-stats",
  templateUrl: "user-stats.html",
  styleUrl: "user-stats.scss",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe],
})
export class UserStatsComponent {
  protected kpis = input.required<WirelessHealthDetail>();

  protected todayMaxActiveUsers = computed(() => this.kpis().today.maxActiveUsers);
  protected last3DaysMaxActiveUsers = computed(() => this.kpis().last3Days.maxActiveUsers);
  protected lastWeekMaxActiveUsers = computed(() => this.kpis().lastWeek.maxActiveUsers);
}
